import { render, staticRenderFns } from "./AltSidebar.vue?vue&type=template&id=2b2dfcd4&scoped=true"
import script from "./AltSidebar.vue?vue&type=script&lang=js"
export * from "./AltSidebar.vue?vue&type=script&lang=js"
import style0 from "./AltSidebar.vue?vue&type=style&index=0&id=2b2dfcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2dfcd4",
  null
  
)

export default component.exports